<template>
	<!--在详情页中，绑定class值-->
  <!-- v-wechat-title:用来修改列表页title -->
  <div class="mainContent clear" v-wechat-title="$route.meta.title" :class="{'active':status}">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    data() {
      return {status: false};
    },
    methods: {
      //在详情页中,背景色改变
      changeColor() {
        this.status = this.$route.name.indexOf('Detail') !== -1;
      }
    },
    // 监听路由变化
    watch: {
      "$route": "changeColor",//路由变化时，改变背景色
    },
  }
</script>

<style scoped lang="scss">
  .mainContent {
    width: 100%;
    min-height: 950px;
    padding-bottom: 200px;
  }

  .active {
    background-color: #f9f8fd;
  }
</style>



// WEBPACK FOOTER //
// content.vue?b78ad3ac